import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  // Redirect empty path to '/dashboard'
  { path: '', pathMatch: 'full', redirectTo: 'users' },

  // Redirect signed-in user to the '/dashboard'
  //
  // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
  // path. Below is another redirection for that path to redirect the user to the desired
  // location. This is a small convenience to keep all main routes together here on this file.
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'users' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-in',
        loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes'),
      },
    ],
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes'),
      },
      {
        path: 'users',
        loadChildren: () => import('app/modules/admin/users/users.routes'),
      },
      {
        path: 'api-keys',
        loadChildren: () => import('app/modules/admin/api-keys/api-keys.routes'),
      },
      {
        path: 'discount-codes',
        loadChildren: () => import('app/modules/admin/discount-codes/discount-codes.routes'),
      },
      // {
      //   path: 'subscriptions',
      //   loadChildren: () => import('app/modules/admin/subscriptions/subscriptions.routes'),
      // },
      {
        path: 'pdf-summaries',
        loadChildren: () => import('app/modules/admin/pdf-summaries/pdf-summaries.routes'),
      },
      {
        path: 'document-types',
        loadChildren: () => import('app/modules/admin/document-types/document-types.routes'),
      },
      {
        path: 'disposable-email',
        loadChildren: () => import('app/modules/admin/disposable-email/disposable-email.routes'),
      },
      {
        path: 'prompts',
        loadChildren: () => import('app/modules/admin/prompts/prompts.routes'),
      },
      {
        path: 'do-spaces',
        loadChildren: () => import('app/modules/admin/spaces/spaces.routes'),
      },
      // {
      //   path: 'example',
      //   loadChildren: () => import('app/modules/admin/example/example.routes'),
      // },
    ],
  },
];
